import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import type { ISearchChallengeResult } from './search-challenges-response';
import { searchChallengesResponseSchema } from './search-challenges-response';

export async function searchChallengesApi(query: string) {
  return getRequest<IAPI<ISearchChallengeResult[]>>({
    path: '/challenges/search',
    options: { params: { query } },
    schema: searchChallengesResponseSchema,
  });
}
